import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { SafeContentPipe } from '@warema/shared/pipes';
import { SvgIconComponent } from './components/svg-icon/svg-icon.component';
import { SvgCacheService } from './services/svg-cache.service';

@NgModule({
    imports: [CommonModule, SafeContentPipe, SvgIconComponent],
    exports: [SvgIconComponent],
    providers: [SvgCacheService],
})
export class SharedSvgModule {}
